import React from 'react';
import Title from 'components/TitleWithIcon';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import {useStyles} from './style';
import StepperCensus from './stepperCensus';

import {Button, AppBar, Toolbar, IconButton, Typography, DialogContent} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SolicitudesEmpadronamiento(props) {
    const classes = useStyles();
    return (
        <div>
            <Dialog  
                open={props.open}
                // maxWidth={"md"}
                // fullWidth={true}
                fullScreen 
                TransitionComponent={Transition}
                keepMounted
                onClose={props.handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={props.handleClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            Procesar Solicitud
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Title title={"SOLICITUD NO. "+props.idSolicitudObtenido+' '+(props.accionDeProceso ? props.accionDeProceso : '')+' '+ (props.isNacional ? props.isNacional :'')} icon={"/menu/Document.png"}/>
                <StepperCensus
                    open={props.open}
                    {...props}
                    // ObtenerTotalDeSolicitudesPendientesDeRealizar={props.ObtenerTotalDeSolicitudesPendientesDeRealizar}
                />
            </Dialog>
        </div>
    );
}